module.exports = __webpack_public_path__ + "img/y_p3_handle.b2d54a6a.svg";